import { NoAvailabilities } from 'webReservations/availability/NoAvailabilities';
import { useAvailabilityContext } from '../context/AvailabilityContext';
import { useRestaurantContext } from '../context/RestaurantContext';
import { MaxGuestCountCopy } from './MaxGuestCountCopy';

export const NoTimes = () => {
  const { hasNoAvailableTimesForSelectedGuestCount, selectedGuestCount } =
    useAvailabilityContext();
  const { restaurantDetails } = useRestaurantContext();

  const selectedGuestCountExceedsRestaurantMax =
    selectedGuestCount > restaurantDetails.maxReservationGuests;

  if (selectedGuestCountExceedsRestaurantMax) {
    return (
      <NoAvailabilities iconName="couple" title="Unsupported Guest Count">
        <MaxGuestCountCopy />
      </NoAvailabilities>
    );
  }

  if (hasNoAvailableTimesForSelectedGuestCount) {
    return (
      <NoAvailabilities>
        <p>Can’t find a table? Adjust date or guests.</p>
      </NoAvailabilities>
    );
  }

  return (
    <NoAvailabilities>
      <p>No times are available.</p>
    </NoAvailabilities>
  );
};
